export default "__VITE_ASSET__BIXZrI1R__"